export enum Variant {
	DarkBackground = 'darkBackground',
	GrayBackground = 'grayBackground',
	LightBackground = 'lightBackground',
}

export type VariantUnion = 'darkBackground' | 'grayBackground' | 'lightBackground'
